import { render, staticRenderFns } from "./replace.vue?vue&type=template&id=9b64d3cc&scoped=true&"
import script from "./replace.vue?vue&type=script&lang=js&"
export * from "./replace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b64d3cc",
  null
  
)

export default component.exports